
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/series/[...slug]",
      function () {
        return require("private-next-pages/resources/series/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/series/[...slug]"])
      });
    }
  